"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsStyled = exports.TabStyled = exports.TabListStyled = exports.TabContentStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var RadixTabs = _interopRequireWildcard(require("@radix-ui/react-tabs"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var TabsStyled = exports.TabsStyled = (0, _styledComponents.default)(RadixTabs.Root).withConfig({
  displayName: "Tabsstyled__TabsStyled",
  componentId: "sc-edajmy-0"
})(["display:flex;flex-direction:column;gap:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.sys.spacing['200'];
});
var TabListStyled = exports.TabListStyled = (0, _styledComponents.default)(RadixTabs.List).withConfig({
  displayName: "Tabsstyled__TabListStyled",
  componentId: "sc-edajmy-1"
})(["display:flex;flex-direction:row;border-bottom:1px solid ", ";width:fit-content;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.sys.color.border.disabled;
});
var TabStyled = exports.TabStyled = (0, _styledComponents.default)(RadixTabs.Trigger).withConfig({
  displayName: "Tabsstyled__TabStyled",
  componentId: "sc-edajmy-2"
})(["display:flex;justify-content:center;align-items:center;gap:", ";height:", ";padding:", "  ", ";outline:none;background-color:", ";border:none;cursor:pointer;&[aria-selected='false']{", " border-bottom:", " solid transparent;}&[aria-selected='true']{", ";border-bottom:", " solid ", ";}&.focus-ring{z-index:1;", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.sys.spacing['100'];
}, _globalTokens.globalSizing['1200'], function (_ref4) {
  var theme = _ref4.theme;
  return theme.sys.spacing['200'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sys.spacing['300'];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sys.color.background.neutral['1'];
}, _tokens.default.sky.sys.font.body['1'], function (_ref7) {
  var theme = _ref7.theme;
  return theme.sys.spacing['100'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.sys.font.subheading['1'];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.sys.spacing['100'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.sys.color.background.primary['3'];
}, _globalTokens.globalShadow.focusRingLight);
var TabContentStyled = exports.TabContentStyled = (0, _styledComponents.default)(RadixTabs.Content).withConfig({
  displayName: "Tabsstyled__TabContentStyled",
  componentId: "sc-edajmy-3"
})(["", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.sys.font.body['1'];
});